export default "__VITE_ASSET__777a1ab4__"